import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Helmet} from "react-helmet";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import TabContext from "@mui/lab/TabContext";
import {useState} from "react";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import GameStageBasicInfo from "../../component/gameStages/gameStageBasicInfo/GameStageBasicInfo";
import TabPanel from "@mui/lab/TabPanel";
import GameRegistrantBasicInformation
    from "../../component/gameRegistrant/gameRegistrantBasicInformation/GameRegistrantBasicInformation";
import GameRegistrantAdditionalInformation
    from "../../component/gameRegistrant/gameRegistrantAdditionalInformation/GameRegistrantAdditionalInformation";
import GamerApprove from "../../component/gameRegistrant/gamerApprove/GamerApprove";

export default function GameRegistrantInformation() {

    const location = useLocation()


    const {gamePeriodId, registrantId} = useParams();
    console.log(gamePeriodId);
    console.log(registrantId);


    const {gamePeriodTitle, gameRegistrantTitle} = location.state || {};

    const navigate = useNavigate()

    //
    // console.log("gamePeriodTitle", gamePeriodTitle)
    // console.log("gameRegistrantTitle", gameRegistrantTitle)
    const [tabSelectedValue, setTabSelectedValue] = useState(gameRegistrantInformationTabTypes.basicInfo.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    return (
        <>
            <Helmet><title>{gameRegistrantTitle}</title></Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Game.name,
                                "",
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.GamePeriod.name,
                                RouteHelper.GamePeriod.globalUrl,
                            ),
                            raikoBreadCrumbItemGenerator(
                                gamePeriodTitle,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                gameRegistrantTitle,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}
                        />
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={gameRegistrantInformationTabTypes.basicInfo.title}
                                    value={gameRegistrantInformationTabTypes.basicInfo.id}/>
                                <Tab
                                    label={gameRegistrantInformationTabTypes.additionalInformation.title}
                                    value={gameRegistrantInformationTabTypes.additionalInformation.id}/>
                                <Tab
                                    label={gameRegistrantInformationTabTypes.approve.title}
                                    value={gameRegistrantInformationTabTypes.approve.id}/>
                            </TabList>
                        </Box>
                        <TabPanel value={gameRegistrantInformationTabTypes.basicInfo.id}>
                            <GameRegistrantBasicInformation registrantId={registrantId}/>
                        </TabPanel>
                        <TabPanel value={gameRegistrantInformationTabTypes.additionalInformation.id}>
                            <GameRegistrantAdditionalInformation registrantId={registrantId}/>
                        </TabPanel>
                        <TabPanel value={gameRegistrantInformationTabTypes.approve.id}>
                            <GamerApprove registrantId={registrantId}/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const gameRegistrantInformationTabTypes = {
    basicInfo: {
        id: "basicInfo",
        title: "اطلاعات پایه",
    },
    additionalInformation: {
        id: "additionalInformation",
        title: "اطلاعات تکمیلی",
    },
    approve: {
        id: "approve",
        title: "پذیرش"
    }

}